import React from 'react';
import Tags from '@atlassian/jira-portfolio-3-portfolio/src/common/view/tags';
import type { Props } from './types';

export default function Labels(props: Props) {
	const { labels, isAdded } = props;
	const title = labels.join(', ');
	return <Tags tooltip={title} tags={labels} isRemoved={!isAdded} width="150px" />;
}
